import PropTypes from "prop-types";
import { useEffect, useState } from "react";

function Timer({ minutes = 0, hours = 0, seconds = 0 }) {
  // convert everything to milliseconds
  const intervalMs =
    (hours * 3600 + minutes * 60 + seconds) * 1000;

  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!intervalMs) return;

    const calculateRemaining = () => {
      const now = Date.now();
      const elapsed = now % intervalMs;
      return intervalMs - elapsed;
    };

    // initial calculation
    setTimeLeft(calculateRemaining());

    const interval = setInterval(() => {
      const remaining = calculateRemaining();
      setTimeLeft(remaining);
    }, 1000);

    return () => clearInterval(interval);
  }, [intervalMs]);

  // format hh:mm:ss
  const formatTime = () => {
    const totalSeconds = Math.floor(timeLeft / 1000);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;

    return `${h.toString().padStart(2, "0")}:${m
      .toString()
      .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  return (
    <div className="w-full flex align-center justify-end m-1">
      ⏱️ Next dashboard refresh in: {formatTime()}
    </div>
  );
}

Timer.propTypes = {
  minutes: PropTypes.number,
  hours: PropTypes.number,
  seconds: PropTypes.number,
};

export default Timer;



